export interface IBookingFilters {
  createdAtFrom: string;
  createdAtTo: string;
  couponId: string;
}

export class BookingFiltersFormValues implements IBookingFilters {
  createdAtFrom: string = '';
  createdAtTo: string = '';
  couponId: string = '';

  constructor(init?: IBookingFilters) {
    Object.assign(this, init);
  }
}
